module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/surgicals/note-7a1fcbddce3af705598582a04ddfaf19.png";